@if (message(); as message) {
  <div class="bandeau-avis" role="alert">
    <div class="container bandeau-avis__contenu">
      <mat-icon class="bandeau-avis__icone" aria-hidden="false"
        [attr.aria-label]="'bandeauAvis.avertissement' | translate">warning</mat-icon>
      <p class="bandeau-avis__texte">{{ message }}</p>
      <button mat-icon-button type="button"
        class="bandeau-avis__fermer"
        [attr.aria-label]="'bandeauAvis.fermer' | translate"
        (click)="fermer()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
}
